import React from "react";
import classes from "./card.module.css";

export const Card = ({
  children,
  className = "",
  style = {},
  onClick,
  ...rest
}) => {
  return (
    <div
      className={`${classes.card} ${className}`.trim()}
      style={style}
      onClick={onClick} 
      {...rest}
    >
      {children}
    </div>
  );
};
